module.exports = __webpack_public_path__ + "img/[啤酒].d57c08cd.svg";